import React from 'react'

import { useStoryReader } from '@hooks/book/useStoryReader'
import { IntroductionProps, IntroductionAcceptProps } from './interface'

export function withIntroduction(Component: React.FC<IntroductionProps>) {
  function Hoc(props: IntroductionAcceptProps) {
    const { data } = useStoryReader()

    const checkIntroExist = (introText: string) => {
      let tempText = introText
      tempText = tempText.replace(/<p>/g, '')
      tempText = tempText.replace(/<\/p>/g, '')
      tempText = tempText.replace(/\s/g, '')
      return Boolean(tempText)
    }

    const newProps = {
      intro: data?.intro || '',
      isIntroExist: checkIntroExist(data?.intro || ''),
      ...props,
    }
    return <Component {...newProps} />
  }

  return Hoc
}
